import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController ,LoadingController, ModalController} from 'ionic-angular';
import { ProductosPorGruposProvider } from '../../providers/productos-por-grupos/productos-por-grupos'
import { CompaniasProvider } from '../../providers/companias/companias'
import { Storage } from '@ionic/storage'
import { reorderArray } from 'ionic-angular';
import { AuthService } from '../../providers/auth-service'
import { NUBE_AWS } from '../../config/url.servicio';
import { UtilsProvider } from '../../providers/utils/utils'

@IonicPage()
@Component({
  selector: 'page-reservas-tipos-por-valor',
  templateUrl: 'reservas-tipos-por-valor.html',
  providers: [ AuthService ]
})
export class ReservasTiposPorValorPage {
  listaProductos = [];
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId
  listaReservas
  tiposReservasPorValor =  []
  tiposReservasId
  listaProductosSeleccionados
  allItems
  buscar:string =''
  realizandoUnaVenta:boolean= true
  queHago:boolean = true
  loader
  valorCuotaString: string= "0";
  valorCuota = 0;
  nombreTiposReserva="";
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicio: ProductosPorGruposProvider,
              public servicioCompania:CompaniasProvider,
              private storage: Storage,
              public alertControllers:AlertController,
              public auth: AuthService,
              public loadingCtrl:LoadingController,
              public modalControllers: ModalController,
              public utils: UtilsProvider) {

    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
    .then((val)=>{
      if(val){
        this.nombreCompaniaHeader = val['nombreCompania']
        this.nombreCargoHeader = val['nombreCargo']

      }
    })
    this.buscarDatos()
  }

  buscarDatos(){
    this.storage.get('companiasId').then((val) => {
      this.companiasId = val
    this.servicio.buscarTiposReservasControlaPrecio(val)
    .subscribe(
      res => {
        this.listaReservas = !NUBE_AWS ? res : JSON.parse(res['_body']).data[0]
      },
      err => {
      }
    )
  })

  }


  reorderItems(indexes) {
    this.tiposReservasPorValor = reorderArray(this.tiposReservasPorValor, indexes);
  }

  ionViewDidLoad() {
  }

  agregarAlCarrito(item) {
        let tiposReservasId = item['tiposReservasId']
        let companiasId = item['companiasId']
        this.servicio.buscarTiposReservasProductosPorGruposDrag(companiasId,tiposReservasId)
        .subscribe((res: any) => {
            this.tiposReservasPorValor =  !NUBE_AWS ? res : JSON.parse(res['_body']).data[0]
            this.nombreTiposReserva = this.tiposReservasPorValor[0].nombre
          },
          err => {
            let alert = this.alertControllers.create({
              title: 'Error',
              subTitle: 'No se pudieron listar los tipos de reserva, intente luego',
              buttons: ['Cerrar']
            });
            alert.present();
          })
      }

      onEvent(event: string, item: any){

        if (event === 'onTextChange') {

         let valor = this.getItems(this.buscar);
         if(valor){
              item = valor
        }
        }
        }

        getItems(event: any): void {
          if(!this.allItems){
            let valores = this.listaProductosSeleccionados
            this.allItems = valores;
          }
            this.listaProductosSeleccionados = this.allItems.filter((item) => {
              return item.nombreProducto.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
            });
      }

      cerrarSession(){
        this.auth.logout()
        this.navCtrl.setRoot('LoginPage');
      }


      buscarUuidGrupos(){

        let data = []
        let valorComparar = Number(this.tiposReservasId)
        for(let k=0;k< this.listaReservas.length;k++){
          if(k === valorComparar){

            data.push({
              tiposReservasId : this.listaReservas[k].tiposReservasId
            })
            k = this.listaReservas.length + 1
          }
        }

        return data

      }

      limpiar(){
        this.listaProductos = []
        this.realizandoUnaVenta = true
        this.tiposReservasId = undefined
        this.buscar=''
      }
      mostrarMensajeDeError(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }
      mostrarMensajeAdvertencia(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Advertencia',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }


      mostrarMensajeExito(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Registro exitoso',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }
      procesarResultado() {
        this.limpiar()
        this.buscarDatos()
      }


      eliminarValor(item:any,i:any){
        console.log(item,i)
      }

      actualizarRegistro(item,i){
        let tiposReservasPorValorId = item.tiposReservasPorValorId
        let valor = item.valor.replace(/[\.,]/g, '');
        let companiasId = item.companiasId
        if(tiposReservasPorValorId!==0){

          this.servicio.actualizarTiposReservasPorValor(companiasId,tiposReservasPorValorId,valor)
          .subscribe((data)=>{
            this.procesarResultado()
            this.utils.mensajeMuestro('Tipo reservas por valor','Registro guardado con exito','success')
          },(error)=>{
            console.log(error)
          })
        }else{
          this.utils.mensajeMuestro('Tipo reservas por valor','Debe ingresar un valor valido','warning')
        }


      }

      searchSimple(cantidadafnSimple:any,item,index){
        setTimeout(() => {

            if(Number(cantidadafnSimple['_value'])==0 || isNaN(cantidadafnSimple['_value']) ){
             return
           }

           let cantidad = Number(cantidadafnSimple['_value'])

           let nuevaCantidad = Number(cantidad)
           return


         },1000)
       }

       DECIMAL_SEPARATOR  = '.'
       GROUP_SEPARATOR = ','

       format(valString) {
         if (!valString) {
             this.valorCuota = 0
             return '';
         }
         let val = valString.toString();
         try {
             this.valorCuota = Number(val.replace(/,/g, ''))
         } catch (e) {
             this.valorCuota = 0
         }

         const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
         return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
     };

     unFormat(val) {
      if (!val) {
          return '';
      }
      val = val.replace(/^0+/, '');

      if (this.GROUP_SEPARATOR === ',') {
          return val.replace(/,/g, '');
      } else {
          return val.replace(/\./g, '');
      }
  };
}



// WEBPACK FOOTER //
// ./src/pages/reservas-tipos-por-valor/reservas-tipos-por-valor.ts